import { useSnackbarContext } from './useSnackbarContext';

export const useSnackbar = () => {
  const { showSuccess, showError, showWarning, showInfo } =
    useSnackbarContext();

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
    // Convenience methods for common use cases
    showMessage: (
      message: string,
      type: 'success' | 'error' | 'warning' | 'info' = 'info'
    ) => {
      switch (type) {
        case 'success':
          showSuccess(message);
          break;
        case 'error':
          showError(message);
          break;
        case 'warning':
          showWarning(message);
          break;
        case 'info':
        default:
          showInfo(message);
          break;
      }
    },
  };
};
